<template>
    <form-wrapper @submit="handleFormSubmission(data)">
        <form-row>
            <form-cell>
                <textarea-field
                    :label="$t('forms.patient_message.fields.password.label')"
                    :placeholder="$t('forms.patient_message.fields.password.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    valuePath="message"
                    @change="change($event)"
                ></textarea-field>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons align="right">
                <common-button
                    icon="send-message"
                    :label="$t('modals.referral_chat_modal.send_message_button')"
                    :isProcessing="isSending"
                    :isDisabled="false"
                    size="small"
                    type="primary"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import MessagesAPI from 'api/MessagesAPI'

    export default {
        mixins: [FormMixin, HandleRequestMixin],

        methods: {
            handleFormSubmission(data) {
                const patientId = parseInt(this.$route.params.id)
                const MessageData = {
                    fromUserId: this.$auth.getUser().id,
                    objectType: 'direct',
                    body: data.message,
                    fromPracticeId: this.$auth.getUser().practiceId,
                    toPatientId: patientId,
                }
                this.handleRequest(MessagesAPI.sendMessage(MessageData))
                    .then(() => {
                        this.emitEvent({ name: 'close' })
                    })
                    .catch(() => {})
            },
        },
    }
</script>
